import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { captureReferralCodeFromUrl } from '../../utils/referralCapture';

/**
 * Persists ?ref= / ?referral_code= from the URL on every route change
 * so signup (modal, dedicated page, OTP) always has the code available.
 */
export function ReferralUrlCapture(): null {
    const location = useLocation();

    useEffect(() => {
        captureReferralCodeFromUrl(`${location.pathname}${location.search}`);
    }, [location.pathname, location.search]);

    return null;
}
